import { useNavigate } from 'react-router';
import { Text, RecommendedSvg } from 'react-gldn-kit';
import { useProviders } from 'react-render-hooks';
import { Provider } from 'react-memory-optimization/dist/lib/store/casino/entities/providers/types';
import { ECasinoCategoryIds } from 'react-memory-optimization/dist/lib/store/casino/entities/categories/types';

import CasinoCategoryRow from '../CasinoCategoryRow';
import RowGames from '../CasinoCategoryRow/components/RowGames';

import { ERouteNames } from 'Routes/types';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './CasinoRecommendedGames.module.css';
import { getProviderGamesPath } from 'Routes/utils';

type Props = {
  providerId: number;
};

const RecommendedGames = ({ providerId }: Props) => {
  const navigate = useNavigate();

  const provider = useHookFabric<Provider>({
    fn: useProviders,
    customProps: {
      isProvider: true,
      providerId,
    },
  });

  const jumpToProvider = () => {
    if (!provider) {
      return;
    }
    navigate(
      getProviderGamesPath({
        page: '1',
        scroll: '0',
        providerNames: [provider.name],
      })
    );
  };

  return (
    <div>
      <div className={styles.recommendedTitle}>
        <RecommendedSvg classes={styles.recommendedGamesSvg} />

        <div className={styles.title}>
          <Text idT="recommendedGames" specValue={provider?.name} />
        </div>
      </div>

      <RowGames
        hookProps={{
          categoryId: null,
          subCategoryId: null,
          page: 0,
          search: '',
          providerId,
        }}
        jumpTo={jumpToProvider}
        classes={styles.marginB}
      />

      <CasinoCategoryRow
        categoryId={ECasinoCategoryIds.Popular}
        subCategoryId={0}
        name="mostPopular"
        disableShowMoreBtn
        rowHeaderClasses={styles.color}
      />
    </div>
  );
};

export default RecommendedGames;
